import { render, staticRenderFns } from "./APIUserEditor.vue?vue&type=template&id=42534ab4&"
import script from "./APIUserEditor.vue?vue&type=script&lang=js&"
export * from "./APIUserEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports